import { track } from '@omnea-app/fe-analytics/useAnalytics'
import type { AnalyticsEvents } from '@omnea-app/packages/universal/analytics'

declare module '@omnea-app/packages/universal/analytics' {
  interface AnalyticsEvents {
    AuctionsWhatsNewClicked: Record<string, never>
    AuctionsWhatsNewNextClicked: { step: number; isLastStep: boolean }
  }
}

export const auctionsWhatsNewAnalytics = {
  clicked: () => track('AuctionsWhatsNewClicked', {}),
  nextClicked: (props: AnalyticsEvents['AuctionsWhatsNewNextClicked']) => track('AuctionsWhatsNewNextClicked', props),
}
